import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const googleIntegrationService = {
    revokeGoogleIntegration,
    authenticateGoogleIntegration,
    getLocations,
    getAccounts,
    editProfile,
    getLocationListing,
    updateLocationListing,
    getCategories,
    createLocation,
    getCreateDefaults,
};

function getLocations(integrationId = null) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    const query = integrationId ? `?integrationId=${integrationId}` : '';
    return fetch(`${BASE_URL}api/google/locations${query}`, requestOptions).then(handleResponse);
}

function getAccounts(integrationId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/google/accounts?integrationId=${integrationId}`, requestOptions).then(handleResponse);
}

function revokeGoogleIntegration(integrationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    const query = integrationId ? `?integrationId=${integrationId}` : '';
    return fetch(`${BASE_URL}api/google/revoke-access${query}`, requestOptions).then(handleResponse);
}

function authenticateGoogleIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/google/authenticate`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.IntegrationConnected, { integration: 'google' }));
}

function editProfile(locationId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/google:connect`, requestOptions).then(
        handleResponse,
    );
}

function getLocationListing(locationId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/google/listing`, requestOptions).then(
        handleResponse,
    );
}

function updateLocationListing(locationId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/google/listing`, requestOptions).then(
        handleResponse,
    );
}

function getCategories(query = '', limit = 50) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/categories?query=${query}&limit=${limit}`, requestOptions).then(
        handleResponse,
    );
}

function createLocation(locationId, integrationId = null, googleAccountId = null) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    const params = new URLSearchParams();
    if (integrationId) {
        params.set('integrationId', integrationId);
    }
    if (googleAccountId) {
        params.set('googleAccountId', googleAccountId);
    }
    const query = params.toString() ? `?${params.toString()}` : '';
    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/google:create${query}`, requestOptions).then(
        handleResponse,
    );
}

function getCreateDefaults(locationId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/google:create-defaults`, requestOptions).then(
        handleResponse,
    );
}
